const ScrollTop = (smooth = true) => window.scrollTo({
  top:0,
  left:0,
  behavior:smooth ? 'smooth' : 'auto'
});

export default ScrollTop;